import type { DataTableColumn, DataTableRenderCellParams } from '@/components/custom/erp/data-table-v2';

export const getDataTableColumns = (): DataTableColumn[] => [
  {
    field: 'ma_kh_data',
    headerName: 'Mã khách hàng',
    width: 150,
    renderCell: (params: DataTableRenderCellParams) => params.row.ma_kh_data?.customer_code || ''
  },
  {
    field: 'ma_dk',
    headerName: 'Mã điều kiện',
    width: 150
  },
  {
    field: 'loai_dk',
    headerName: 'Loại điều kiện',
    width: 150,
    renderCell: (params: DataTableRenderCellParams) => {
      const loaiDK = params.row.loai_dk;
      return loaiDK === '1'
        ? '1 - Thanh toán vào ngày cố định trong tháng'
        : loaiDK === '2'
          ? '2 - Thanh toán vào ngày cố định trong tuần'
          : loaiDK;
    }
  },
  {
    field: 'so_ngay',
    headerName: 'Số ngày thanh toán',
    width: 150,
    renderCell: (params: DataTableRenderCellParams) => params.row.so_ngay || 0
  },
  {
    field: 'ten_dk',
    headerName: 'Tên điều kiện',
    width: 250
  }
];
